"use strict";

var PropTypes = require("prop-types");

var classNames = require("classnames");
var LoggerInstance = require("js-logger").get("Quantity");
var React = require("react");

var ProductActions = require("../actions/ProductActions");

var ProductStore = require("../stores/ProductStore");

class Quantity extends React.Component {
	constructor(props) {
		super(props);

		this.state = { selectedQuantity: 1 };

		this._onChange = this._onChange.bind(this);
	}

	handleAmountChange(event) {
		// must be whole number, > 0
		if (event.currentTarget.value === "0") {
			ProductActions.setQuantity(1, this.props.tangibleCode, this.state.context);
		} else if (event.currentTarget.value.match(/^\d*$/)) {
			ProductActions.setQuantity(event.currentTarget.value, this.props.tangibleCode, this.state.context);
		}
	}

	handleAmountBlur(event) {
		// must be whole number, > 0
		var quantity = event.currentTarget.value;
		var isValidQuantity = quantity.match(/^[1-9]\d*$/) !== null;

		if (!isValidQuantity) {
			ProductActions.setQuantity(1, this.props.tangibleCode, this.state.context);
		} else {
			ProductActions.setQuantity(quantity, this.props.tangibleCode, this.state.context);
		}
	}

	getStateFromStore() {
		return {
			selectedQuantity: ProductStore.getSelectedQuantity(this.state.context, this.props.tangibleCode)
		};
	}

	_onChange() {
		this.setState(this.getStateFromStore());
	}

	componentDidMount() {
		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentLoaded(this);
		}
		var context = this.props.context;
		var contextId = "";
		if (context) {
			switch (context) {
				case "tangible":
					context = "category";
					contextId = $(ReactDOM.findDOMNode(this)).closest("[data-component=category]").attr("id");

					if (!contextId) {
						contextId = $(ReactDOM.findDOMNode(this)).closest("[data-component=carousel]").attr("id");
						if (contextId) {
							context = "carousel";
						}
					}
					break;
				case "result":
					context = "search";
					contextId = $(ReactDOM.findDOMNode(this)).closest("[data-component=searchResults]").attr("id");
					break;
			}
			context += `_${contextId}`;
		}
		// At this point, selectedQuantity has been set by the component
		ProductActions.setQuantity(this.state.selectedQuantity, this.props.tangibleCode, context, /* isInitialization */ true);
		this.setState({ context });
		ProductStore.addChangeListener(this._onChange);

		//I don't necessarily like doing this but CheckoutActions, outside of the commonComponents bundle needs to know when to attach quantity change listener.
		if (!this.state.context && !this.props.tangibleCode) {
			$("body").trigger("mainProductQuantityMounted");
		}
	}

	componentWillUnmount() {
		ProductStore.removeChangeListener(this._onChange);

		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentUnloaded(this);
			ProductActions.setQuantity(null, this.props.tangibleCode, this.state.context);
		}
	}

	render() {
		var quantity = this.state.selectedQuantity;

		return (
			<span
				data-react-component-name="Quantity"
				data-react-component-category="ProductComponents"
				data-component-id={this.props.dataComponentId}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
			>
				<input
					type="text"
					value={quantity == null ? 1 : quantity}
					onChange={this.handleAmountChange.bind(this)}
					onBlur={this.handleAmountBlur.bind(this)}
					className={classNames(this.props.className, !this.state.context && !this.props.tangibleCode ? "main-product-quantity" : "")}
					data-override-classes={this.props.className}
					inputMode="numeric"
				/>
			</span>
		);
	}
}

Quantity.propTypes = {
	className: PropTypes.string,
	isDesignMode: PropTypes.bool,
	context: PropTypes.string,
	tangibleCode: PropTypes.string,
	theme: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string
};

module.exports = Quantity;
